module.exports = __webpack_public_path__ + "img/come-fix-you-a-plate_desktop.5256d64.jpg";